/*
 * @Author: yzhao
 * @Date: 2022-06-29 15:20:17
 * @LastEditors: yzhao
 * @LastEditTime: 2022-06-29 15:28:19
 * @Description: file content
 */
let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
    <ownerCode>货主编码, string (50), 必填</ownerCode>
    <virtualWarehouse>虚拟仓库, string (50), 条件必填, 条件为使用虚拟仓库</virtualWarehouse>
    <queryType>查询类型, int, 0=动销商品库存, 必填</queryType>
    <startTime>开始时间, string (10), YYYY-MM-DD HH:MM:SS,必填</startTime>
    <endTime>结束时间, string (10), YYYY-MM-DD HH:MM:SS, 必填</endTime>
    <page>当前页, int,当前页, 从1开始, 默认1</page>
    <pageSize>每页条数, int,数值范围1-1000, 默认1000</pageSize>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
    <totalCount>总数, int</totalCount>
    <items>
        <item>
            <warehouseCode>仓库编码, string (50)</warehouseCode>
            <ownerCode>货主编码, string (50)</ownerCode>
            <itemCode>商品编码, string (50)</itemCode>
            <itemId>仓储系统商品ID, string (50)</itemId>
            <virtualWarehouse>虚拟仓库, string (50)</virtualWarehouse>
            <inventoryType>质量状态,string (50), ZP=正品, CC=残次, 默认ZP</inventoryType>
            <quantity>可用数量, int</quantity>
            <lockQuantity>已分配数量, int</lockQuantity>
            <productQty>总数量, int</productQty>
            <productDate>商品生产日期, string (10), YYYY-MM-DD</productDate>
            <expireDate>商品过期日期, string (10), YYYY-MM-DD</expireDate>
            <batchCode>批次号, string (50)</batchCode>
            <stockinDate>商品入库日期, string (10), YYYY-MM-DD</stockinDate>
            <userDefined1>自定义批次1, string (50)</userDefined1>
            <userDefined2>自定义批次2, string (50)</userDefined2>
            <userDefined3>自定义批次3, string (50)</userDefined3>
            <userDefined4>自定义批次4, string (50)</userDefined4>
       </item>
   </items>
</response>
`

let NotificaitonURL = 'NotificaitonURL'

export default { xmlRequest, xmlResponse, NotificaitonURL }



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.conditioninventory.query.js